/* eslint-disable react-hooks/exhaustive-deps */
import Box from "@mui/material/Box";
import { SetStateAction, useContext, useEffect, useRef, useState } from "react";
import { Loading } from "react-admin";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import { theme } from "../../theme";
import AlertForm from "./AlertForm";
import { alertOverview as classes } from "./styles";
import { APIContext } from "../../store/APIStore";
import { useParams } from "react-router-dom";
import { StoreContext } from "../../store/Store";
import NotificationMessage, {
  notificationType,
} from "../NotificationMessage/NotificationMessage";
import DropdownButton from "../DropdownButton/DropdownButton";
import { balance_outstanding, initialData } from "./data";
import { v4 as uuidv4 } from "uuid";
import { RiAlertLine } from "react-icons/ri";
import { ICreateAlert } from "./type";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import AlertList from "./AlertList";

const AlertOverview = () => {
  const [loading] = useState(false);
  const api = useContext(APIContext);
  const [state, dispatch] = useContext(StoreContext);
  const notificationRef = useRef<any>();
  const { alertList } = state;
  const [modifyAlert, setCreateAlert] = useState({
    createAlert: false,
    updateAlert: false,
  });
  const { eventId } = useParams() as any;
  const [selectedId, setSelectedId] = useState(0);

  const fetchAlertData = async () => {
    try {
      const alerts = (await api.alertService.getAlerts({
        id: eventId,
      })) as unknown as ICreateAlert[];
      dispatch({ type: "SET_ALERT_LIST", payload: alerts });
      if (alerts?.length > 0) {
        setCreateAlert((prev) => ({
          ...prev,
          createAlert: false,
          updateAlert: true,
        }));
      } else {
        setCreateAlert((prev) => ({
          ...prev,
          createAlert: false,
          updateAlert: false,
        }));
      }
    } catch (error: any) {
      console.log(error);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  useEffect(() => {
    fetchAlertData();
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }
  }, []);

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  useEffect(() => {
    const defaultEdit = alertList?.find(
      (el: ICreateAlert) => el.id === selectedId
    );
    dispatch({
      type: "SET_SELECTED_ALERT",
      payload: defaultEdit || (alertList && alertList[0]),
    });
  }, [alertList]);

  const handleIdSelect = (id: SetStateAction<number>) => {
    setSelectedId(id);
  };
  const canViewInternalApi = useHasPermissions(
    PERMISSIONS.CAN_VIEW_INTERNAL_API
  );

  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.topActions}>
          <FdTypography label="Alerts" variant="h3" />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              paddingRight="20px"
            >
              <RiAlertLine
                style={{
                  marginRight: "5px",
                  color: theme.palette.text.primary,
                  fontSize: "18px",
                }}
                size="18"
              />
              <FdTypography variant="body1" label="Total number of alerts:" />
              <FdTypography
                variant="body1"
                fontWeight="bold"
                label={alertList?.length}
              />
            </Box>
            <DropdownButton
              label="Add new alert"
              endIcon={<BiChevronDown />}
              options={
                canViewInternalApi
                  ? [
                      {
                        key: "outstanding-balance-alert",
                        label: "Outstanding Balance Alert",
                        callback: () => {
                          setCreateAlert((prev) => ({
                            ...prev,
                            createAlert: true,
                            updateAlert: false,
                          }));
                          dispatch({
                            type: "SET_SELECTED_ALERT",
                            payload: {
                              ...balance_outstanding,
                              thirdPartyId: uuidv4(),
                            },
                          });
                        },
                      },
                      {
                        key: "generic-alert",
                        label: "Generic Alert",
                        callback: () => {
                          dispatch({
                            type: "SET_SELECTED_ALERT",
                            payload: initialData,
                          });
                          setCreateAlert((prev) => ({
                            ...prev,
                            createAlert: true,
                            updateAlert: false,
                          }));
                        },
                      },
                    ]
                  : [
                      {
                        key: "outstanding-balance-alert",
                        label: "Outstanding balance alert",
                        callback: () => {
                          setCreateAlert((prev) => ({
                            ...prev,
                            createAlert: true,
                            updateAlert: false,
                          }));
                          dispatch({
                            type: "SET_SELECTED_ALERT",
                            payload: {
                              ...balance_outstanding,
                              thirdPartyId: uuidv4(),
                            },
                          });
                        },
                      },
                    ]
              }
            />
          </Box>
        </Box>
        {loading ? (
          <Loading />
        ) : (
          <Box sx={classes.listContent}>
            <Box sx={classes.alertRoot}>
              {alertList?.length !== 0 ? (
                <AlertList
                  list={alertList}
                  fetchAlertData={fetchAlertData}
                  setUpdate={() =>
                    setCreateAlert((prev) => ({
                      ...prev,
                      createAlert: false,
                      updateAlert: true,
                    }))
                  }
                />
              ) : (
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box textAlign="center">
                    <RiAlertLine
                      style={{
                        position: "relative",
                        top: "5px",
                        marginRight: "5px",
                        color: theme.palette.primary.main,
                        fontSize: "18px",
                      }}
                      size="100"
                    />
                    <FdTypography label="There are no alerts configured" />
                  </Box>
                </Box>
              )}
            </Box>
            {(modifyAlert.createAlert || modifyAlert.updateAlert) && (
              <>
                <BiChevronRight size="50" color={theme.palette.grey["800"]} />
                <AlertForm
                  fetchAlertData={fetchAlertData}
                  alertModify={modifyAlert}
                  setSelectedId={handleIdSelect}
                />
              </>
            )}
          </Box>
        )}
        <NotificationMessage ref={notificationRef} />
      </Box>

      {/* <NotificationMessage ref={notificationRef} /> */}
    </>
  );
};

export default AlertOverview;
